var _defs, _path, _path2, _path3, _path4, _path5, _path6, _ellipse, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgI4CLamps = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 530,
    height: 332,
    viewBox: "0 0 530 332",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4c-lamps-image-a",
    x1: "50.325%",
    x2: "50.048%",
    y1: "8.056%",
    y2: "97.225%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4c-lamps-image-b",
    x1: "15.635%",
    x2: "14.337%",
    y1: "-54.49%",
    y2: "33.194%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4c-lamps-image-c",
    x1: "32.738%",
    x2: "31.442%",
    y1: "-33.006%",
    y2: "54.679%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i4c-lamps-image-d",
    x1: "49.843%",
    x2: "48.546%",
    y1: "-11.521%",
    y2: "76.164%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4c-lamps-image-a)",
    d: "M497.520612,0 C507.778571,0 516.119388,3.96693674 516.119388,9.07504706 L530,332 L469,332 L479.419796,9.45543825 C479.407347,4.34732793 487.262653,0.0815123987 497.520612,0 Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4c-lamps-image-b)",
    d: "M342.508163,0 C352.766122,0 361.09449,3.97181252 361.106939,9.08620125 L375,332 L314,332 L324.444694,9.46705998 C324.394898,4.46148804 332.250204,0.081612586 342.508163,0 Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4c-lamps-image-c)",
    d: "M186.508163,0 C196.766122,0 205.09449,3.97181252 205.106939,9.08620125 L219,332 L158,332 L168.444694,9.46705998 C168.394898,4.46148804 176.3,0.081612586 186.508163,0 Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#i4c-lamps-image-d)",
    d: "M30.5081633,0 C40.7661224,0 49.0944898,3.97181252 49.1069388,9.08620125 L63,332 L2,332 L12.4073469,9.46705998 C12.394898,4.46148804 20.2502041,0.081612586 30.5081633,0 Z",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M498.027344,13.9988838 C481.458808,14.0672211 468.015114,10.9891124 468,7.12373557 C467.984911,3.25835878 481.404121,0.0694534652 497.972656,0.00111619631 C514.541192,-0.0672210725 527.984886,3.01088764 528,6.87626443 C528.015089,10.7416412 514.595879,13.9305465 498.027344,13.9988838 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M498.022787,10.999123 C484.215674,11.0528166 473.012595,8.63430257 473,5.59722081 C472.987426,2.56013904 484.170101,0.0545705798 497.977213,0.000877011383 C511.784326,-0.052816557 522.987405,2.36569743 523,5.40277919 C523.012574,8.43986096 511.829899,10.9454294 498.022787,10.999123 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M499.016403,7.99936191 C489.075282,8.03841988 481.009067,6.2795073 481,4.07072071 C480.990949,1.86193412 489.042476,0.0396960594 498.983597,0.00063809096 C508.924718,-0.0384198774 516.990933,1.7204927 517,3.92927929 C517.009051,6.13806588 508.957524,7.96030394 499.016403,7.99936191 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M498.886706,0 C506.866363,0 513.61838,1.06153846 516,2.59615385 C514.772361,4.47692308 507.308313,5.96538462 498.186952,6 C490.195019,6 483.455279,4.93846154 481,3.40384615 C482.252192,1.52307692 489.765345,0.0346153846 498.886706,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M343.027344,13.9988838 C326.458808,14.0672211 313.015114,10.9891124 313,7.12373557 C312.984911,3.25835878 326.404121,0.0694534652 342.972656,0.00111619631 C359.541192,-0.0672210725 372.984886,3.01088764 373,6.87626443 C373.015089,10.7416412 359.595879,13.9305465 343.027344,13.9988838 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M318,5.60116496 C318,8.63463169 329.203266,11.0470737 343.018564,10.9993026 C356.833862,10.9515315 368.012369,8.44354717 368,5.41008044 C367.98761,2.3766137 356.759586,0 342.944288,0 C329.12899,0 318,2.55575544 318,5.60116496 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M342.016403,7.99936191 C332.075282,8.03841988 324.009067,6.2795073 324,4.07072071 C323.990949,1.86193412 332.042476,0.0396960594 341.983597,0.00063809096 C351.924718,-0.0384198774 359.990933,1.7204927 360,3.92927929 C360.009051,6.13806588 351.957524,7.96030394 342.016403,7.99936191 Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M341.87443,0 C349.854086,0 356.606103,1.06153846 359,2.59615385 C357.772361,4.47692308 350.308313,5.96538462 341.186952,6 C333.195019,6 326.455279,4.93846154 324,3.40384615 C325.239916,1.52307692 332.753069,0.0346153846 341.87443,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M186.027344,13.9988838 C169.458808,14.0672211 156.015114,10.9891124 156,7.12373557 C155.984911,3.25835878 169.404121,0.0694534652 185.972656,0.00111619631 C202.541192,-0.0672210725 215.984886,3.01088764 216,6.87626443 C216.015089,10.7416412 202.595879,13.9305465 186.027344,13.9988838 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M187.022787,10.999123 C173.215674,11.0528166 162.012595,8.63430257 162,5.59722081 C161.987426,2.56013904 173.170101,0.0545705798 186.977213,0.000877011383 C200.784326,-0.052816557 211.987405,2.36569743 212,5.40277919 C212.012574,8.43986096 200.829899,10.9454294 187.022787,10.999123 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M186.016403,7.99936191 C176.075282,8.03841988 168.009067,6.2795073 168,4.07072071 C167.990949,1.86193412 176.042476,0.0396960594 185.983597,0.00063809096 C195.924718,-0.0384198774 203.990933,1.7204927 204,3.92927929 C204.009051,6.13806588 195.957524,7.96030394 186.016403,7.99936191 Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M185.886706,0 C193.866363,0 200.61838,1.06153846 203,2.59615385 C201.772361,4.47692308 194.308313,5.96538462 185.186952,6 C177.195019,6 170.455279,4.93846154 168,3.40384615 C169.252192,1.52307692 176.765345,0.0346153846 185.886706,0 Z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M30.0273439,13.9988838 C13.4588084,14.0672211 0.0151143448,10.9891124 0,7.12373557 C-0.0150888774,3.25835878 13.4041207,0.0694534652 29.9726561,0.00111619631 C46.5411916,-0.0672210725 59.9848857,3.01088764 60,6.87626443 C60.0150889,10.7416412 46.5958793,13.9305465 30.0273439,13.9988838 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C5C5C5",
    d: "M5,5.60116496 C5,8.63463169 16.2032977,11.0470737 30.0185843,10.9993026 C43.833871,10.9515315 55.012369,8.44354717 55,5.41008044 C54.9876104,2.3766137 43.7843538,0 29.9690672,0 C16.1537805,0 4.97528247,2.55575544 5,5.60116496 Z",
    style: {
      mixBlendMode: "multiply"
    }
  }), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 5,
    fill: "#C5C5C5",
    rx: 18,
    ry: 4
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M29.8867064,0 C37.8663627,0 44.6183795,1.06153846 47,2.59615385 C45.7723606,4.47692308 38.3083129,5.96538462 29.1869519,6 C21.1950193,6 14.4552788,4.93846154 12,3.40384615 C13.2521922,1.52307692 20.7653455,0.0346153846 29.8867064,0 Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgI4CLamps, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/i4c-lamps.8483ab99.svg";
export { ForwardRef as ReactComponent };